export default "__VITE_ASSET__6370ce38__"